export const mergeVisibleContracts = (realtimeContracts = [], firestoreContracts = []) => {
  const archivedIds = new Set(
    [...realtimeContracts, ...firestoreContracts]
      .filter((contract) => contract?.archived === true)
      .map((contract) => String(contract.id || ""))
      .filter(Boolean)
  );
  const contractsById = new Map();

  [...realtimeContracts, ...firestoreContracts].forEach((contract) => {
    const contractId = String(contract?.id || "");
    if (!contractId || archivedIds.has(contractId)) {
      return;
    }
    contractsById.set(contractId, contract);
  });

  return Array.from(contractsById.values()).sort((a, b) =>
    String(a.id).localeCompare(String(b.id), undefined, { numeric: true })
  );
};
